import { UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { useTranslate } from 'sbx-crm-menu-ui';
import FloatComponent from 'src/components/shared/FloatComponent';
import { AiAgentV3 } from 'src/types/AiAgentV3';
import { defaultColorsBotV3 } from 'src/utils/botGenerator/formatCss';
import useIgnoreRenderEffect from '../../../../hooks/useIgnoreRenderEffect';
import { useState } from 'react';
import { ColorPaletteComponent } from '../../../shared/ColorPalleteComponent';
import { addSpanToDivs } from 'src/utils';

interface Props {
    watch: UseFormWatch<AiAgentV3>;
    setValue: UseFormSetValue<AiAgentV3>;
    oldExtraConfig: Record<string, any>;
}

interface ColorConfig {
    selector: string;
    keys: string[];
    labels?: string[];
    classNameLabel?: string;
    indexColor?: number;
    className?: string;
    addSpan?: boolean;
}

function getColorsBot(values: any, colors: any, key: string) {
    if (values[key]) return values[key];
    return colors[key];
}

const classNameLabel = 'text-purple-700 font-semibold text-[14px]';

const colorConfigs: ColorConfig[] = [
    {
        selector: '.fbw-panel',
        keys: ['fbw_bg_grad_start', 'fbw_bg_grad_end', 'fbw_border_color'],
        labels: ['grad_start_label', 'grad_end_label', 'border_label'],
        classNameLabel,
        className: 'float-bubble-tr',
        indexColor: 2,
    },
    {
        selector: '.fbw-name',
        keys: ['fbw_text'],
        className: 'float-bubble-tl',
        addSpan: true
    },
    {
        selector: '.fbw-desc',
        keys: ['fbw_text_muted'],
        className: 'float-bubble-br',
        addSpan: true
    },
    {
        selector: '.fbw-msg-bot .fbw-msg-text',
        keys: ['fbw_bg_bot'],
        className: 'float-bubble-br',
    },
    {
        selector: '.fbw-msg-bot .fbw-msg-name',
        keys: ['fbw_bot_header_text'],
        className: 'float-bubble-br',
    },
    {
        selector: '.fbw-msg-bot .fbw-msg-body',
        keys: ['fbw_bot_text'],
        className: 'float-bubble-tr',
        addSpan: true
    },
    {
        selector: '.fbw-msg .fbw-msg-meta',
        keys: ['fbw_text_muted'],
        className: 'float-bubble-tr',
    },
    {
        selector: '.fbw-btn.fbw-btn-send',
        keys: ['fbw_accent'],
        className: 'float-bubble-tr',
    },
    {
        selector: '.fbw-toggle',
        keys: ['fbw_accent'],
        className: 'float-bubble-bl',
    },
    {
        selector: '.fbw-powered-label',
        keys: ['fbw_bot_footer_text'],
        className: 'float-bubble-bl',
        addSpan: true
    },
    {
        selector: '.fbw-msg-head',
        keys: ['fbw_bot_icon_header_msg'],
        className: 'float-bubble-tl',
    },
];

const AgentPopUpColorsComponent = ({ watch, setValue }: Props) => {
    const { t } = useTranslate('agent');
    const values = watch('look_and_feel_chat.extra_config');
    const [startedBot, setStartedBot] = useState(false);
    const [botOpened, setBotOpened] = useState(false);
    const [configColors, setConfigColors] = useState(colorConfigs);

    useIgnoreRenderEffect(() => {
        window.addEventListener('onBotService', (evt: any) => {
            switch (evt.detail.type) {
                case 'botStarted':
                    setStartedBot(true);

                    break;
                case 'openCloseChat':
                    setBotOpened(evt.detail.info.open);
                    break;
                case 'userMessage':
                    setTimeout(() => addSpanToDivs(), 500);
                    if (!configColors.some((clr) => clr.selector.includes('.fbw-msg-user .fbw-msg-text'))) {
                        setConfigColors([
                            ...configColors,
                            {
                                selector: '.fbw-msg-user .fbw-msg-text',
                                keys: ['fbw_bg_user'],
                                className: 'float-bubble-bl',
                            },
                            {
                                selector: '.fbw-msg-user .fbw-msg-text .fbw-msg-body',
                                keys: ['fbw_user_text'],
                                className: 'float-bubble-br',
                            },
                        ]);
                    }
                    break;
            }
        });
    }, []);

    return (
        <>
            {configColors.map((color, index) => {
                const nColor = `linear-gradient(to right, ${color.keys.map((key) => `var(--${key.replaceAll('_', '-')})`).join(', ')})`;
                return (
                    <FloatComponent
                        key={index}
                        deps={[startedBot, botOpened]}
                        querySelectorId={color.selector}
                        style={{
                            background: nColor,
                        }}
                        className={color.className}
                        addSpan={color.addSpan}
                    >
                        <div className="flex flex-col gap-4">
                            {color.keys.map((key, i) => (
                                <ColorPaletteComponent
                                    key={key}
                                    value={getColorsBot(values, defaultColorsBotV3, key)}
                                    onChange={(val) => setValue(`look_and_feel_chat.extra_config.${key}`, val)}
                                    label={color.labels?.[i] ? t(color.labels[i]) : undefined}
                                />
                            ))}
                        </div>
                    </FloatComponent>
                );
            })}
        </>
    );
};

export default AgentPopUpColorsComponent;
